import { Header } from "@/components/Header";
import { Wallet } from "lucide-react";
import { ManualeButton } from "@/components/ManualeButton";
import { PrimaNotaCassaTab } from "@/pages/contabilita/PrimaNotaCassaTab";

export default function PrimaNotaCassa() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <div className="mb-6 flex items-start justify-between gap-3 flex-wrap">
          <div>
            <div className="flex items-center gap-2 text-slate-900"><Wallet className="h-6 w-6 text-teal-600" /><h1 className="font-heading text-2xl font-bold">Prima Nota Cassa</h1></div>
            <p className="text-sm text-slate-500 mt-1">Registro di cassa dell'Agenzia · movimenti, versamenti e riconciliazione interna.</p>
          </div>
          <ManualeButton route="/manuale/prima-nota" />
        </div>
        <PrimaNotaCassaTab />
      </main>
    </div>
  );
}
